import { computed } from 'vue'
import { type GatButtonProps } from '../../gat-button/gat-button.vue'
import { type GatDropdownMenuProps } from '../gat-dropdown-menu.vue'

export function useGatDropdownMenuProps(props: GatDropdownMenuProps) {
  function onActivatorClicked() {
    if (props.onClick) {
      if (Array.isArray(props.onClick)) {
        props.onClick.forEach((e) => e())
      } else {
        props.onClick()
      }
    }
  }

  const gatButtonProps = computed(
    (): GatButtonProps => ({
      text: props.text,
      label: props.label,
      disabled: props.disabled,
      icon: props.icon,
      mainAction: props.mainAction,
      // onClick:() onActivatorClicked(),
      size: props.size,
      tooltip: props.tooltip,
      type: props.type,
      variant: props.variant,
      iconPosition: props.iconPosition,
      layoutClass: props.layoutClass
    })
  )

  return {
    gatButtonProps,
    onActivatorClicked
  }
}
